import React, { useState, useEffect } from 'react';
import { useHistory, useParams } from 'react-router-dom';
import { trackPromise } from 'react-promise-tracker';
import {
    cadastrarBuyer,
    detalheEmpresaBuyer,
    atualizarBuyer,
    inativarBuyer,
    ativarBuyer,
    obterTermoBuyer,
    obterTermoBuyerCadastro
} from '../../../../../services/http/buyerService';
import FormControlLabel from '@material-ui/core/FormControlLabel';
import FormGroup from '@material-ui/core/FormGroup';
import Checkbox from '@material-ui/core/Checkbox';
import { buscarEnderecoPorCep } from '../../../../../services/http/cepService';

import services from '../../../../../services';

import { useSnackBar } from '../../../../../hooks/snackBar';

import { useFormik } from 'formik';
import {
    formBuyerValidator,
    mapearData,
    formBuyerInitialState,
    mapearResponseApi
} from './formBuyerValidator';
import { estados, cidadesBrasil } from '../../../../../services/estadosBrasil';

import FormControl from '@material-ui/core/FormControl';
import TextField from '@material-ui/core/TextField';
import InputLabel from '@material-ui/core/InputLabel';
import MenuItem from '@material-ui/core/MenuItem';
import Select from '@material-ui/core/Select';

import CurrencyTextField from '@unicef/material-ui-currency-textfield';

import './styles.scss';
import globals from '../../../../../globals';

const MenuProps = {
    PaperProps: {
        style: {
            maxHeight: 48 * 4.5 + 8,
            width: 250
        }
    },
    getContentAnchorEl: null,
    anchorOrigin: {
        vertical: "bottom",
        horizontal: "center"
    },
    transformOrigin: {
        vertical: "top",
        horizontal: "center"
    },
    variant: "menu"
};

const FormBuyer = () => {

    const { idEmpresa } = useParams();

    const history = useHistory();
    const { addSnackBar } = useSnackBar();

    const [empresaBuyer, setEmpresaBuyer] = useState(formBuyerInitialState);
    const [cidades, setCidades] = useState([]);
    const [disabledBtnInativar, setDisabledBtnInativar] = useState(false);
    const [inputendereco, setInputendereco] = useState({
        logradouro: false,
        bairro: false,
        estado: false,
        cidade: false
    });

    const [termoAceite, setTermoAceite] = useState({});

    const formik = useFormik({
        initialValues: empresaBuyer,
        validationSchema: formBuyerValidator,
        onSubmit: (values) => {
            if (idEmpresa) {
                handleAtualizarBuyer(values)
            } else {
                handlerSalvar(values);
            }
        },
    })

    useEffect(() => {
        if (idEmpresa === null || idEmpresa === undefined) {
            setDisabledBtnInativar(true);
        }

        CarregarDetalhesEmpresaBuyer();
    }, []);

    useEffect(() => {
        if (idEmpresa != null || idEmpresa != undefined) {
            constRecuperarInformacaoTermo();
        }
    }, []);

    const constRecuperarInformacaoTermo = () => {
        if (idEmpresa) {
            trackPromise(
                obterTermoBuyer(idEmpresa, `${globals.REACT_APP_URL_BASE_FRONT_PORTAL}`)
                    .then(res => {
                        setTermoAceite(res.data)
                    })
            ).catch(error => {
                console.log(error);
            })
        }
    }

    useEffect(() => {
        preencherCidades(formik.values.estado)
    }, [formik.values.estado])

    const enderecoPorCep = (cep) => {
        trackPromise(
            buscarEnderecoPorCep(cep)
                .then(res => {
                    if (!res.fail && res.data.uf.sigla) {
                        listarCidadesBrasil(res.data.uf.sigla);

                        formik.setValues((prevent) => ({
                            ...prevent,
                            cep: res.data.cep,
                            logradouro: res.data.logradouro,
                            bairro: res.data.bairro,
                            estado: res.data.uf.sigla,
                            cidade: res.data.cidade.nome
                        }))


                        setInputendereco({
                            logradouro: true,
                            bairro: true,
                            estado: true,
                            cidade: true
                        });

                    }
                })
        ).catch(error => {
            console.log(error);
        })
    }

    const CarregarDetalhesEmpresaBuyer = () => {
        trackPromise(
            detalheEmpresaBuyer(idEmpresa)
                .then(res => {
                    if (res.data) {
                        console.log(res.data);
                        let data = mapearResponseApi(res.data);
                        formik.setValues(data);
                    }
                }).catch(error => {

                    addSnackBar({
                        message: 'Erro ao tentar obter informações de cadastro',
                        info: 'error',
                        open: true
                    });
                })
        )
    }

    const listarCidadesBrasil = (uf) => {
        trackPromise(
            cidadesBrasil(uf)
                .then(res => {
                    if (res.data) {
                        setCidades(res.data);
                    } else {
                        addSnackBar({ message: 'Não foi possível carregar as cidades', info: 'warning', open: true });
                    }
                }).catch(error => {
                    addSnackBar({ message: 'Erro aa carregar cidades', info: 'error', open: true });
                })
        )
    }

    const preencherCidades = (value) => {
        if (value !== '') {
            listarCidadesBrasil(value);
        }
    }

    const handleAtivarBuyer = () => {
        trackPromise(
            ativarBuyer(idEmpresa)
                .then(res => {
                    addSnackBar({
                        message: 'Buyer ativado com sucesso',
                        info: 'success',
                        open: true
                    });

                    handleCancelar();
                })
        ).catch(error => {
            console.log(error);
        })
    }

    const handleInativarBuyer = () => {

        trackPromise(
            inativarBuyer(idEmpresa)
                .then(res => {
                    if (res.fail) {
                        addSnackBar({
                            message: "Erro ao tentar inativar buyer",
                            info: 'error',
                            open: true
                        });
                        return;
                    }

                    addSnackBar({
                        message: "Buyer inativado com sucesso",
                        info: 'success',
                        open: true
                    });

                    handleCancelar();
                }).catch(error => {
                    addSnackBar({
                        message: 'Erro ao tentar inativar buyer',
                        info: 'error',
                        open: true
                    });
                })
        )
    }

    const handleAtualizarBuyer = (values) => {
        values.cnpj = services.mask.unMask(values.cnpj);
        values.cep = services.mask.unMask(values.cep);
        values.telefone = services.mask.unMask(values.telefone);
        let data = mapearData(values);

        trackPromise(
            atualizarBuyer(idEmpresa, data)
                .then(res => {
                    if (res.fail) {
                        res.errors.forEach(item => {
                            addSnackBar({
                                message: item.menssagem,
                                info: 'warning',
                                open: true
                            });
                        })
                        return;
                    }

                    addSnackBar({
                        message: 'Buyer atualizado com sucesso',
                        info: 'success',
                        open: true
                    });

                    history.push(`/admin/buyer/${idEmpresa}`)

                }).catch(error => {
                    addSnackBar({
                        message: 'Erro ao atualizar buyer',
                        info: 'error',
                        open: true
                    });
                })
        )
    }

    const obtertermoAposSalvarBuyer = (idBuyer) => {
        trackPromise(
            obterTermoBuyerCadastro(idBuyer)
                .then(res => {
                    if (!res.fail) {
                        setTermoAceite(res.data)
                    }else{
                        addSnackBar({
                            message: 'Erro ao obter termo',
                            info: 'error',
                            open: true
                        }); 
                    }

                })
        ).catch(error => {
            console.log(error);
        })
    }

    const handlerSalvar = (values) => {
        values.cnpj = services.mask.unMask(values.cnpj);
        values.cep = services.mask.unMask(values.cep);
        values.telefone = services.mask.unMask(values.telefone);
        //alert(values.tipo);
        values.tipo = values.tipo === 'selecione' ? '' : values.tipo;

        let data = mapearData(values);
        data.linkBaseTermoFront = globals.REACT_APP_URL_BASE_FRONT_PORTAL;
        trackPromise(
            cadastrarBuyer(data)
                .then(res => {
                    console.log(res);
                    if (res.fail) {

                        res.errors.forEach(item => {
                            addSnackBar({
                                message: item.menssagem,
                                info: 'warning',
                                open: true
                            });
                        })
                        return;
                    }
                    else {
                        obtertermoAposSalvarBuyer(res.data);
                    }

                    addSnackBar({
                        message: 'Buyer cadastrado com sucesso',
                        info: 'success',
                        open: true
                    });

                    history.push(`/admin/buyer/${res.data}`)

                }).catch(error => {
                    addSnackBar({
                        message: 'Erro ao tentar cadastrar buyer',
                        info: 'error',
                        open: true
                    });
                })
        )
    }

    const handleCancelar = () => {
        history.push('/admin/buyers');
    }

    return (
        <div>
            <div className="modal">
                <div className="modalContent">
                    <iframe src="http://www.africau.edu/images/default/sample.pdf" style={{ width: '600px', height: '500px' }} frameborder="0"></iframe>
                </div>
            </div>

            <form className="ml-1 mt20" onSubmit={formik.handleSubmit}>
                <div className="row"><div className="col-sm-12 col-md-12 col-lg-12 font"><strong>Detalhes da Empresa</strong></div></div>
                <div className="row">
                    <div className="col-sm-2 col-md-2 col-lg-2">
                        <FormControl>
                            <TextField
                                label="CNPJ *"
                                placeholder="00000000000000"
                                type="text"
                                size="small"
                                id="cnpj"
                                variant="outlined"
                                value={services.mask.cpfCnpj(formik.values.cnpj)}
                                onChange={formik.handleChange}
                                error={formik.touched.cnpj && Boolean(formik.errors.cnpj)}
                                helperText={formik.touched.cnpj && formik.errors.cnpj}
                            />
                        </FormControl>
                    </div>

                    <div className="col-sm-2 col-md-2 col-lg-2">
                        <FormControl>
                            <TextField
                                label="IE"
                                placeholder="000000"
                                type="text"
                                size="small"
                                id="ie"
                                variant="outlined"
                                value={formik.values.ie}
                                onChange={formik.handleChange}
                                error={formik.touched.ie && Boolean(formik.errors.ie)}
                                helperText={formik.touched.ie && formik.errors.ie}
                            />
                        </FormControl>
                    </div>

                    <div className="col-sm-2 col-md-2 col-lg-2">
                        <FormControl>
                            <TextField
                                label="IM"
                                placeholder="000000"
                                type="text"
                                size="small"
                                id="im"
                                variant="outlined"
                                value={formik.values.im}
                                onChange={formik.handleChange}
                                error={formik.touched.im && Boolean(formik.errors.im)}
                                helperText={formik.touched.im && formik.errors.im}
                            />
                        </FormControl>
                    </div>

                    <div className="col-sm-3 col-md-3 col-lg-3">
                        <FormControl>
                            <TextField
                                label="Razão Social *"
                                placeholder="Informe a Razão Social"
                                type="text"
                                size="small"
                                id="razaoSocial"
                                variant="outlined"
                                value={formik.values.razaoSocial}
                                onChange={formik.handleChange}
                                error={formik.touched.razaoSocial && Boolean(formik.errors.razaoSocial)}
                                helperText={formik.touched.razaoSocial && formik.errors.razaoSocial}
                            />
                        </FormControl>
                    </div>

                    <div className="col-sm-3 col-md-3 col-lg-3">
                        <FormControl>
                            <TextField
                                label="Nome Fantasia *"
                                placeholder="Informe o Nome Fantasia"
                                type="text"
                                size="small"
                                id="nomeFantasia"
                                variant="outlined"
                                value={formik.values.nomeFantasia}
                                onChange={formik.handleChange}
                                error={formik.touched.nomeFantasia && Boolean(formik.errors.nomeFantasia)}
                                helperText={formik.touched.nomeFantasia && formik.errors.nomeFantasia}
                            />
                        </FormControl>
                    </div>
                </div>
                <div className="row">
                    <div className="col-sm-3 col-md-3 col-lg-3">
                        <FormControl>
                            <TextField
                                label="Telefone / Celular"
                                placeholder="(00) 00000-0000"
                                type="text"
                                size="small"
                                id="telefone"
                                variant="outlined"
                                value={services.mask.phoneoucelularuser(formik.values.telefone)}
                                onChange={formik.handleChange}
                                error={formik.touched.telefone && Boolean(formik.errors.telefone)}
                                helperText={formik.touched.telefone && formik.errors.telefone}
                            />
                        </FormControl>
                    </div>

                    <div className="col-sm-2 col-md-2 col-lg-2">
                        <FormControl>
                            <TextField
                                label="CEP"
                                placeholder="00000-000"
                                type="text"
                                size="small"
                                id="cep"
                                variant="outlined"
                                onBlur={event => enderecoPorCep(event.target.value)}
                                value={services.mask.cep(formik.values.cep)}
                                onChange={formik.handleChange}
                                error={formik.touched.cep && Boolean(formik.errors.cep)}
                                helperText={formik.touched.cep && formik.errors.cep}
                            />
                        </FormControl>
                    </div>

                    <div className="col-sm-5 col-md-5 col-lg-5">
                        <FormControl>
                            <TextField
                                //inputProps={{ style: { color: inputendereco.logradouro ? 'black' : 'none', fontWeight: inputendereco.logradouro ? 'bold' : 'normal' } }}
                                label="Logradouro"
                                placeholder="Informe o endereço"
                                type="text"
                                size="small"
                                id="logradouro"
                                variant="outlined"
                                //disabled={inputendereco.logradouro}
                                value={formik.values.logradouro}
                                onChange={formik.handleChange}
                                error={formik.touched.logradouro && Boolean(formik.errors.logradouro)}
                                helperText={formik.touched.logradouro && formik.errors.logradouro}
                            />
                        </FormControl>
                    </div>

                    <div className="col-sm-2 col-md-2 col-lg-2">
                        <FormControl>
                            <TextField
                                label="Número"
                                placeholder="000000"
                                type="text"
                                size="small"
                                id="numero"
                                variant="outlined"
                                value={formik.values.numero}
                                onChange={formik.handleChange}
                                error={formik.touched.numero && Boolean(formik.errors.numero)}
                                helperText={formik.touched.numero && formik.errors.numero}
                            />
                        </FormControl>
                    </div>

                </div>
                <div className="row">

                    <div className="col-sm-3 col-md-3 col-lg-3">
                        <FormControl>
                            <TextField
                                label="Complemento"
                                placeholder="Informe o complemento"
                                type="text"
                                size="small"
                                id="complemento"
                                variant="outlined"
                                value={formik.values.complemento}
                                onChange={formik.handleChange}
                                error={formik.touched.complemento && Boolean(formik.errors.complemento)}
                                helperText={formik.touched.complemento && formik.errors.complemento}
                            />
                        </FormControl>
                    </div>

                    <div className="col-sm-3 col-md-3 col-lg-3">
                        <FormControl>
                            <TextField
                                //inputProps={{ style: { color: inputendereco.bairro ? 'black' : 'none', fontWeight: inputendereco.logradouro ? 'bold' : 'normal' } }}
                                label="Bairro"
                                placeholder="Informe o Bairro"
                                type="text"
                                size="small"
                                id="bairro"
                                //disabled={inputendereco.bairro}
                                variant="outlined"
                                value={formik.values.bairro}
                                onChange={formik.handleChange}
                                error={formik.touched.bairro && Boolean(formik.errors.bairro)}
                                helperText={formik.touched.bairro && formik.errors.bairro}
                            />
                        </FormControl>
                    </div>

                    <div className="col-sm-2 col-md-2 col-lg-2">
                        <FormControl>
                            <InputLabel id="demo-simple-select-helper-label">Estado</InputLabel>
                            <Select
                                required
                                className="select"
                                variant="outlined"
                                //SelectDisplayProps={{ style: { color: inputendereco.estado ? 'black' : 'none', fontWeight: inputendereco.logradouro ? 'bold' : 'normal' } }}
                                id="estado"
                                //disabled={inputendereco.estado}
                                value={(formik.values.estado != null && formik.values.estado != '' ? formik.values.estado.toUpperCase() : 'selecione')}
                                label="Estado"
                                onChange={formik.handleChange('estado')}
                                MenuProps={MenuProps}
                                error={formik.touched.estado && Boolean(formik.errors.estado)}
                            >
                                <MenuItem disabled={true} value={"selecione"}>
                                    <em>Selecione o estado</em>
                                </MenuItem>

                                {estados.map(es =>
                                    <MenuItem value={es}>{es}</MenuItem>
                                )}
                            </Select>
                        </FormControl>
                    </div>

                    <div className="col-sm-4 col-md-4 col-lg-4">
                        <FormControl>
                            <InputLabel id="demo-simple-select-helper-label">Cidade</InputLabel>
                            <Select
                                required
                                className="select"
                                //SelectDisplayProps={{ style: { color: inputendereco.cidade ? 'black' : 'none', fontWeight: inputendereco.logradouro ? 'bold' : 'normal' } }}
                                id="cidade"
                                variant="outlined"
                                //disabled={inputendereco.cidade}
                                value={(formik.values.cidade != null && formik.values.cidade != '' ? formik.values.cidade.toUpperCase() : 'selecione')}
                                label="Cidade"
                                onChange={formik.handleChange('cidade')}
                                MenuProps={MenuProps}
                                error={formik.touched.cidade && Boolean(formik.errors.cidade)}
                            >
                                <MenuItem disabled={true} value={"selecione"}>
                                    <em>Selecione sua cidade</em>
                                </MenuItem>

                                {cidades.map(cd =>
                                    <MenuItem value={cd.nome.toUpperCase()}>{cd?.nome}</MenuItem>
                                )}
                            </Select>
                        </FormControl>
                    </div>
                </div>
                <div className="row">
                    <div className="col-sm-12 col-md-12 col-lg-12">
                        <FormControl>
                            <TextField
                                label="URL Google Maps"
                                placeholder="Informe a URL"
                                type="text"
                                size="small"
                                id="urlGoogleMaps"
                                variant="outlined"
                                value={formik.values.urlGoogleMaps}
                                onChange={formik.handleChange}
                                error={formik.touched.urlGoogleMaps && Boolean(formik.errors.urlGoogleMaps)}
                                helperText={formik.touched.urlGoogleMaps && formik.errors.urlGoogleMaps}
                            />
                        </FormControl>
                    </div>
                </div>
                <div className="row">
                    <div className="col-sm-3 col-md-3 col-lg-3">
                        <FormControl>
                            <InputLabel id="demo-simple-select-helper-label">Tipo</InputLabel>
                            <Select
                                className="select"
                                variant="outlined"
                                id="tipo"
                                value={(formik.values.tipo != null && formik.values.tipo != '' ? formik.values.tipo : 'selecione')}
                                label="Tipo"
                                onChange={formik.handleChange('tipo')}
                                MenuProps={MenuProps}
                                error={formik.touched.tipo && Boolean(formik.errors.tipo)}
                            >
                                <MenuItem disabled={true} value={"selecione"}>
                                    <em>Selecione o tipo</em>
                                </MenuItem>
                                <MenuItem value={"Varejo"}>Varejo</MenuItem>
                                <MenuItem value={"Distribuidor"}>Distribuidor</MenuItem>
                                <MenuItem value={"Atacado"}>Atacado</MenuItem>
                            </Select>
                        </FormControl>
                    </div>
                    <div className="col-sm-3 col-md-3 col-lg-3">
                        <FormControl>
                            <TextField
                                label="Porte"
                                type="text"
                                size="small"
                                id="porte"
                                variant="outlined"
                                value={formik.values.porte}
                                onChange={formik.handleChange}
                                error={formik.touched.porte && Boolean(formik.errors.porte)}
                                helperText={formik.touched.porte && formik.errors.porte}
                            />
                        </FormControl>
                    </div>
                    <div className="col-sm-2 col-md-2 col-lg-2">
                        <FormControl>
                            <TextField
                                label="Número de Lojas"
                                type="number"
                                size="small"
                                id="numeroLojas"
                                variant="outlined"
                                value={formik.values.numeroLojas}
                                onChange={formik.handleChange}
                                error={formik.touched.numeroLojas && Boolean(formik.errors.numeroLojas)}
                                helperText={formik.touched.numeroLojas && formik.errors.numeroLojas}
                            />
                        </FormControl>
                    </div>
                    <div className="col-sm-2 col-md-2 col-lg-2">
                        <FormControl>
                            <TextField
                                label="Número de Checkouts"
                                type="number"
                                size="small"
                                id="numeroCheckouts"
                                variant="outlined"
                                value={formik.values.numeroCheckouts}
                                onChange={formik.handleChange}
                                error={formik.touched.numeroCheckouts && Boolean(formik.errors.numeroCheckouts)}
                                helperText={formik.touched.numeroCheckouts && formik.errors.numeroCheckouts}
                            />
                        </FormControl>
                    </div>
                    <div className="col-sm-2 col-md-2 col-lg-2">
                        <FormControl>
                            <CurrencyTextField
                                label="Faturamento médio"
                                type="text"
                                size="small"
                                id="faturamentoMedio"
                                variant="outlined"
                                currencySymbol="R$"
                                decimalCharacter=","
                                digitGroupSeparator="."
                                value={formik.values.faturamentoMedio || "0"}
                                onChange={(event, value) => formik.setFieldValue('faturamentoMedio', value)}
                                error={formik.touched.faturamentoMedio && Boolean(formik.errors.faturamentoMedio)}
                                helperText={formik.touched.faturamentoMedio && formik.errors.faturamentoMedio}
                            />
                        </FormControl>
                    </div>
                </div>
                <div className="row">
                    <div className="col-sm-12 col-md-12 col-lg-12 mt20 font">
                        <strong>Dados Financeiros</strong>
                    </div>
                </div>
                <div className="row">
                    <div className="col-sm-4 col-md-4 col-lg-4">
                        <FormControl>
                            <TextField
                                label="Banco"
                                type="select"
                                size="small"
                                id="banco"
                                variant="outlined"
                                value={formik.values.banco}
                                onChange={formik.handleChange}
                                error={formik.touched.banco && Boolean(formik.errors.banco)}
                                helperText={formik.touched.banco && formik.errors.banco}
                            />
                        </FormControl>
                    </div>
                    <div className="col-sm-4 col-md-4 col-lg-4">
                        <FormControl>
                            <TextField
                                label="Agência"
                                type="text"
                                size="small"
                                id="agencia"
                                variant="outlined"
                                value={formik.values.agencia}
                                onChange={formik.handleChange}
                                error={formik.touched.agencia && Boolean(formik.errors.agencia)}
                                helperText={formik.touched.agencia && formik.errors.agencia}
                            />
                        </FormControl>
                    </div>
                    <div className="col-sm-4 col-md-4 col-lg-4">
                        <FormControl>
                            <TextField
                                label="C/C"
                                type="text"
                                size="small"
                                id="contaCorrente"
                                variant="outlined"
                                value={formik.values.contaCorrente}
                                onChange={formik.handleChange}
                                error={formik.touched.contaCorrente && Boolean(formik.errors.contaCorrente)}
                                helperText={formik.touched.contaCorrente && formik.errors.contaCorrente}
                            />
                        </FormControl>
                    </div>
                </div>

                {idEmpresa && (
                    <div>
                        <div className="row"><div className="col-sm-12 col-md-12 col-lg-12 font"><strong>Termos e Condições</strong></div></div>
                        <div className="row">
                            <div className="col-sm-12 col-md-12 col-lg-12 font">
                                <FormGroup>
                                    <FormControlLabel
                                        control={<Checkbox checked={termoAceite.termoAceite ? true : false} disabled={termoAceite.termoAceite ? true : false} />} label="Li e aceito os Termos e Condições Gerais de Venda de Produtos" size="small" />
                                </FormGroup>
                            </div>
                        </div>
                        <div className="row" style={{ marginTop: '-15px' }}>
                            <div className="col-sm-12 col-md-12 col-lg-12 font">
                                <FormGroup>
                                    <FormControlLabel
                                        control={<Checkbox checked={termoAceite.aceiteMensagemOferta ? true : false} disabled={termoAceite.aceiteMensagemOferta ? true : false} />} label="Aceito receber mensagens de ofertas de produtos e serviços com fins promocionais através de meios eletrônicos, incluindo WhatsApp" size="small" />
                                </FormGroup>
                            </div>

                        </div>
                        {(!termoAceite.termoAceite || !termoAceite.aceiteMensagemOferta) && (<div className="row">
                            <div className="col-sm-12 col-md-12 col-lg-12 mb-5 font termolink" >
                                <span>Termo de aceite: <strong style={{ color: 'blue' }}><a href={termoAceite.link} target='_blank'>{termoAceite.link}</a></strong></span>
                            </div>
                        </div>)}


                    </div>


                )}

                <div className="col-sm-12 col-md-12 col-lg-12  flex flex-end buttons">
                    {
                        !idEmpresa && (
                            <button
                                className="col-sm-3 col-md-3 col-lg-3 buton-white-black-border"
                                onClick={handleCancelar}
                            >
                                CANCELAR
                            </button>
                        )
                    }
                    <button
                        className={!idEmpresa
                            ? 'col-sm-3 col-md-3 col-lg-3 buton-green'
                            : 'col-sm-6 col-md-6 col-lg-6 buton-green'
                        }
                        type="submit"
                    >
                        SALVAR
                    </button>
                </div>


                {
                    idEmpresa && (
                        <div className="col-sm-12 col-md-12 col-lg-12  flex flex-end buttons">
                            <button
                                className="col-sm-3 col-md-3 col-lg-3 mt20 buton-white-black-border"
                                onClick={handleCancelar}
                            >
                                CANCELAR
                            </button>
                            {
                                idEmpresa && (
                                    formik.values.ativo
                                        ? <button
                                            type='button'
                                            disabled={disabledBtnInativar}
                                            className="col-sm-3 col-md-3 col-lg-3 mt20 buton-center-green-black-border"
                                            onClick={handleInativarBuyer}
                                        >
                                            INATIVAR
                                        </button>
                                        : <button
                                            type="button"
                                            disabled={disabledBtnInativar}
                                            className="col-sm-3 col-md-3 col-lg-3 mt20 buton-center-green-black-border"
                                            onClick={handleAtivarBuyer}
                                        >
                                            ATIVAR
                                        </button>
                                )
                            }
                        </div>
                    )
                }
            </form>

        </div>
    )
}

export default FormBuyer;